export { default } from './ProfileCardSmall';
